export default "__VITE_ASSET__BvbtSE4$__"